export default __webpack_public_path__ + "images/li-69a1d60ca3996705d91f1f4bd4825b5a.svg";